import { render } from "./LegalComponent.vue?vue&type=template&id=91d55a86&scoped=true"
import script from "./LegalComponent.vue?vue&type=script&lang=js"
export * from "./LegalComponent.vue?vue&type=script&lang=js"

import "./LegalComponent.vue?vue&type=style&index=0&id=91d55a86&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d55a86"]])

export default __exports__